export default __webpack_public_path__ + "88d59ef6d1f3449115935d6ceb41dc4b.svg";